import {
  AuditReport,
  localToUtc,
  stringToDate,
} from '@vcd-ecm-ui/Common';
import { GenericGridRowDataTemplate } from '@vcd-ecm-ui/GenericGrid';

// This is the Native Data Type used in the Grid
export declare type GridDataNativeType = AuditReport;

// This is the Data for Each Grid Row
export default class GridRowData implements GenericGridRowDataTemplate {
  startDateTime: Date;
  auditBeginDate: Date;
  auditEndDate: Date;

  key: string; // Unique Key for Each Row - Required by VtxTable
  rowData: GridDataNativeType;

  constructor(rowData: GridDataNativeType) {
    this.rowData = rowData;
    this.setKey();

    this.setStartDateTime();
    this.setAuditBeginDate();
    this.setAuditEndDate();

    const proxyHandler = {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      get: (instance: GridRowData, prop: string): any => ((prop in instance) && ((instance as any)[prop] !== undefined)
        ? (instance as any)[prop] // eslint-disable-line @typescript-eslint/no-explicit-any
        : (rowData as any)[prop]), // eslint-disable-line @typescript-eslint/no-explicit-any
    };

    const proxy = new Proxy(this, proxyHandler);

    return proxy;
  }

  public static fromData(rowData: GridDataNativeType): GridRowData {
    return new GridRowData(rowData);
  }

  private setStartDateTime(): void {
    this.startDateTime = localToUtc(stringToDate(this.rowData.startDateTime));
  }

  private setKey(): void {
    this.key = this.rowData.reportUuid;
  }

  private setAuditBeginDate(): void {
    this.auditBeginDate = localToUtc(stringToDate(this.rowData.auditBeginDate));
  }

  private setAuditEndDate(): void {
    this.auditEndDate = localToUtc(stringToDate(this.rowData.auditEndDate));
  }
}
